import { ALTERAR_REGISTROS_POR_PAGINA_ITINERARIO } from '../types'

export default function alterarRegistrosPorPaginaItinerario (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_ITINERARIO,
    payload: valor
  }
}
